import { useCallback } from 'react'
import { useBlockedUsers as useTownsBlockedUsers } from 'use-towns-client'

export const useBlockedUsers = () => {
    const { blockedUserIds } = useTownsBlockedUsers()

    return useCallback(
        (userId: string | undefined) => {
            if (userId === undefined) {
                return false
            }
            return blockedUserIds.has(userId)
        },
        [blockedUserIds],
    )
}
